<template>
  <div class="not-found">
    <h1 class="h1">Страница не найдена</h1>
  </div>
</template>

<script>
  export default {
    name: "NotFound"
  }
</script>

<style>
  .not-found {
    text-align: center;
  }
</style>